import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingComponent } from './reporting.component';
import { ReportingRoutingModule } from './reporting-routing.module';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { AppCommonModule } from 'src/app/common/app.common/app.common.module';
import { OperatorsComponent } from './operators/operators.component';
import { TrafficComponent } from './traffic/traffic.component';
import { FormsModule } from '@angular/forms';
import { AdsComponent } from './ads/ads.component';

@NgModule({
  imports: [
    CommonModule,
    ReportingRoutingModule,
    NzGridModule,
    AppCommonModule,
    FormsModule
  ],
  declarations: [
    ReportingComponent,
    OperatorsComponent,
    TrafficComponent,
    AdsComponent
  ]
})
export class ReportingModule { }
